import React from 'react'
import Mision from '../home-page-v2/mission'
import MailContact from '../home-page-v2/mail-contact'
import Offices from '../home-page-v2/offices'
import SocialNetwork from '../home-page-v2/ui/social-network-footer'
import PagesLinks from '../home-page-v2/ui/page-links'
import LogoSlogan from '../home-page-v2/ui/logo-slogan'
import Partners from '../home-page-v2/partners'
import Disclaimer from '../home-page-v2/disclaimer'

const Footer = () => (
  <>
    <Mision />
    <MailContact />
    <Offices />
    <SocialNetwork />
    <PagesLinks />
    <LogoSlogan />
    <Partners />
    <Disclaimer />
  </>
)

export default Footer
